<template>
<div>
    <v-container>
        <v-layout row wrap>
            <!-- -------------------------- -->
            <v-flex xs12 sm12 md5>
                <v-card outlined class="pa-2" height="100%">
                    <div>
                        <v-layout row wrap fill-height class="light-bg pa-2">
                            <v-flex>
                                <p class="text-color pb-0">Visitor Details</p>
                            </v-flex>
                            <v-flex  v-show="this.role=='Office Admin'">
                                <v-btn class="float_right" 
                                text small color="primary" v-on:click="blacklistVisitor()"
                                >{{Visitor_list_type}}</v-btn>
                            </v-flex>
                        </v-layout>
                        <v-layout row wrap class="mb-3">
                            <v-flex xs3 sm2 md2 class="p-5">
                                <v-flex v-if="visitor_details.image">
                                    <v-img :src="storage_path()+visitor_details.image.path" max-width="150" max-height="150"  ></v-img>
                                </v-flex>
                                <v-flex v-else>
                                    <v-img src="@/assets/images/index.png" max-width="150" max-height="150"></v-img>
                                </v-flex>
                            </v-flex>
                            <v-flex xs8 sm9>
                                <v-layout row wrap>
                                    <v-flex xs12>
                                        <v-list-item dense>
                                            <v-list-item-content>
                                                <h3 class="text-color mt-2">{{ visitor_details.name |capitalize}}</h3>
                                               
                                            </v-list-item-content>
                                            <v-list-item-content  v-show="this.role=='Office Admin'" v-if="this.blacklist">
                                              
                                                 <v-chip color="red"  dark>Visitor is Blacklisted </v-chip>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-list-item dense>
                                        <v-list-item-content>
                                            <v-list-item-subtitle>Mobile</v-list-item-subtitle>
                                            <v-list-item-title v-if="visitor_details.mobile!=null">{{this.visitor_details.mobile}}</v-list-item-title>
                                        </v-list-item-content>
                                        <v-list-item-content>
                                            <v-list-item-subtitle>Email</v-list-item-subtitle>
                                            <v-list-item-title v-if="visitor_details.email!=null">{{this.visitor_details.email}}</v-list-item-title>
                                            <v-list-item-title v-else>-</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                        <v-divider></v-divider>
                        <v-layout row wrap>
                            <v-flex xs12>
                                <div>
                                    <v-list-item dense>
                                        <v-list-item-content>
                                            <v-list-item-subtitle>Type</v-list-item-subtitle>
                                            <v-list-item-title v-if="visitor_details.type!=null">{{this.visitor_details.type |capitalize }}</v-list-item-title>
                                        </v-list-item-content>
                                        <v-list-item-content>
                                            <v-list-item-subtitle>Created On</v-list-item-subtitle>
                                            <v-list-item-title v-if="visitor_details.created_at!=null">{{formatDate(this.visitor_details.created_at)}}</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </div>
                                <div>

                                </div>
                            </v-flex>
                        </v-layout>
                    </div>
                </v-card>
            </v-flex>
            <!-- -------------------------- -->
            <v-flex xs12 sm12 md7>
                <v-card outlined class="pa-2" height="100%">
                    <div>
                        <v-layout row wrap fill-height class="light-bg pa-2">
                            <v-flex xs9>
                                <p class="text-color">Visits</p>
                            </v-flex>
                        </v-layout>
                        <v-divider></v-divider>
                        <v-layout row wrap fill-height class="innerheader">
                            <v-flex xs12>
                                <v-data-table 
                                    :headers="visit_headers" 
                                    :items="visitor_related_visits" 
                                    class="elevation-1" 
                                    :loading="is_loading"
                                    :options.sync="options" 
                                    :footer-props="{'items-per-page-options': [5,10,15,20,40]}"
                                    :items-per-page="5"
                                    >
                                    
                                    <template v-slot:body="{ items }" v-if="!is_loading && count!='0'">
                                        <tbody>
                                            <tr v-for="item in items" :key="item.id">
                                                <td v-if="item.image">
                                                    <!-- <router-link :to="{ name:'showVisitDetails',params: { id:item.id } }"> -->
                                                        <v-avatar size="36">
                                                            <img :src="storage_path()+item.image.path" @click="fullWidthImage(item.image.path)">
                                                        </v-avatar>
                                                    <!-- </router-link> -->
                                                </td>
                                                <td v-else>
                                                    <!-- <router-link :to="{ name:'showVisitDetails',params: { id:item.id } }"> -->
                                                        <v-avatar size="36">
                                                            <img src="@/assets/images/index.png">
                                                        </v-avatar>
                                                    <!-- </router-link> -->
                                                </td>
                                                <td v-if="item.type">{{ item.type.toUpperCase().replace(/_/g, " ")}}</td><td v-else> - </td>
                                                <td v-if="item.time">{{ formatDateTime(item.time)}}</td><td v-else> - </td>
                                                <td v-if="item.purpose">{{ item.purpose}}</td>
                                                <td v-else>-</td>
                                                <td  v-show="role!='Office Admin'" v-if="item.office ">
                                                    <router-link :to="{ name:'showOfficeDetails',params: { id:item.office.id } }">{{ item.office.name }}</router-link>
                                                </td>
                                                <td v-else> - </td>

                                            </tr>
                                        </tbody>
                                    </template>
                                <template v-slot:detail_loader> Loading... Please wait </template>
                                <template v-slot:no-data> No data available </template>
                                    
                                </v-data-table>
                            </v-flex>
                        </v-layout>
                    </div>
                </v-card>
            </v-flex>
            <!-- -------------------------- -->
        </v-layout>

    <!-- Image Dialog -->

    <v-dialog
      v-model="image_dialog_box"
      max-width="290"
      max-height="290"
    >
      <v-card>
         <v-img :src="storage_path()+image_path" ></v-img> 
      </v-card>
    </v-dialog>
    </v-container>
</div>
</template>

<script>
export default {
    methods: {
        getVisitorDetails: function () {
            this.is_loading = true;
            axios.get(`${process.env.VUE_APP_API_URL}/api/visitors/` + this.$route.params.id).then(response => {
                    if (response.data.status == 1) {
                        this.visitor_details = response.data.visitor_details;
                        this.visitor_related_visits = response.data.visitor_details.visits;
                        this.count = this.visitor_related_visits.length;
                         
                        if(this.visitor_details.is_blacklisted.length)
                        {
                                this.blacklist = this.visitor_details.is_blacklisted[0].is_blacklisted;
                         
                                if(this.visitor_details.is_blacklisted[0].is_blacklisted==0){
                                    this.Visitor_list_type ='Blacklist Visitor';
                                }else{
                                    this.Visitor_list_type='Whitelist Visitor';
                                }
                        }
                        else{
                           this.Visitor_list_type ='Blacklist Visitor'; 
                            this.blacklist=0;
                        }
                       
                        this.is_loading = false;
                    }
                })
                .catch(error => {
                    console.log(error);
                    this.detail_loader = false;
                }).finally(() => {

                });
        },

        blacklistVisitor(){
          
            this.detail_loader = true;
            if( this.Visitor_list_type =='Blacklist Visitor')
            {
                  this.visitor_list_type_object.type = 1;
            }else{
                   this.visitor_list_type_object.type = 0;
            }
            
             this.visitor_list_type_object.id =  this.$route.params.id;
          
          
            axios.post(`${process.env.VUE_APP_API_URL}/api/visitors/` +
            this.$route.params.id + `/blacklist`,  this.visitor_list_type_object).
            then(response => {
               
                    if (response.data.status == 1) {
                         this.getVisitorDetails();
                    }
                })
                .catch(error => {
                    console.log(error);
                }).finally(() => {

                });
        },
        fullWidthImage(item_image){
            
            this.image_dialog_box =true;
            this.image_path = item_image;
            
        },
        getColumnfilter() {
            if (this.role == 'Office Admin') {
                this.visit_headers = [{
                        text: 'Image',
                        align: 'left',
                        value: 'image',
                        sortable:false
                    },
                    {
                        text: 'Type',
                        value: 'type',
                        sortable:false
                    },
                    {
                        text: 'Visit Date',
                        value: 'time',
                        sortable:false
                    },
                    {
                        text: 'Purpose',
                        value: 'purpose',
                        sortable:false
                    },
                    
                ];
            } else {
                this.visit_headers = [{
                        text: 'Image',
                        align: 'left',
                        value: 'image',
                        sortable:false
                    },
                    {
                        text: 'Type',
                        value: 'type',
                        sortable:false
                    },
                    {
                        text: 'Visit Date',
                        value: 'time',
                        sortable:false
                    },
                    {
                        text: 'Purpose',
                        value: 'purpose',
                        sortable:false
                    },
                    {
                        text: 'Office',
                        value: 'office_id',
                        sortable: false,
                    },
                ];
            }
        },
    },
    data() {
        return {
            default_visitor_image: "/visits_images/index.png",
            role: '',
            count:'',
            options: {},
         is_loading: false,
         detail_loader:false,
            total_items: 10,

            visit_headers: [],
            visitor_related_visits: [],
            visitor_list_type_object:{ type:'',id:''},
            visitor_details: {},
 
            image_dialog_box:false,
            image_path:"",

            Visitor_list_type:' ',
            blacklist:''
           

        }
    },
    mounted() {
        this.role = localStorage.getItem('visitor_management_role');
        
        this.getColumnfilter();
        this.getVisitorDetails();
    }
};
</script>
<style>
    
</style>
